import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from "./home.component";

const routes: Routes = [
    { path: 'home', component: HomeComponent}
];

export const HomeRoutingProvider = RouterModule.forRoot(routes, { useHash: true });